import { render } from "./RankExample.vue?vue&type=template&id=21d65e79"
import script from "./RankExample.vue?vue&type=script&lang=js"
export * from "./RankExample.vue?vue&type=script&lang=js"
script.render = render

export default script